import React from "react";
import Heros from "../components/Heros";
import AboutUs from "../images/ayushi-gallery.jpg";
import Cards from "../components/gallery/Cards";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Category from "../components/gallery/Category";
import GalleryType from "../components/gallery/GalleryType";
import GalleryCategory from "../components/gallery/GalleryCategory";
import { Helmet } from "react-helmet-async";

function Gallery() {
  return (
    <>
      <Helmet>
        <title>Project Gallery | Ayushi Construction Jabalpur</title>
        <meta
          name="description"
          content="See the quality of our work. Browse photos of completed and ongoing residential projects by Ayushi Construction across Jabalpur, including flats, villas, and townships."
        />
        <meta
          name="keywords"
          content="residential project photos jabalpur, construction gallery jabalpur, ayushi construction project images"
        />
        <link rel="canonical" href="https://ayushiconstruction.com/gallery" />
      </Helmet>

      <Heros title="Gallery" backgroundImage={AboutUs} />
      <GalleryCategory />
      <GalleryType />
      {/* <Cards /> */}
    </>
  );
}

export default Gallery;
